import { TypeKeys } from '../actions/index.js';
import { getPreviousActionState, updateActionStatePhase } from '../common/index.js';
import { ActionPhase } from '../common/storeUtils.js';
import {
  mergeArrays,
  reduceDisplayItemsLoadAction,
  validateLoadActionFulfilledResponseCounts,
} from './reducerUtils.js';
import type { VirtualCatalogsState } from '../../common/types/states.js';
import type { VirtualCatalog } from '../../generated/api/models.js';
import type { ActionTypes } from '../actions/index.js';
import type { ActionsHistory } from '../common/store.js';

const sortByLastModifiedAscVirtualCatalog = (a: VirtualCatalog, b: VirtualCatalog) =>
  (a.lastModified ?? 0) - (b.lastModified ?? 0);

export function virtualCatalogsReducer(
  state: (VirtualCatalogsState & ActionsHistory) | undefined | null,
  action: ActionTypes
): (VirtualCatalogsState & ActionsHistory) | null {
  if (typeof state === 'undefined') {
    return null;
  }

  switch (action.type) {
    case TypeKeys.LOAD_VIRTUAL_CATALOGS: {
      const itemsState = reduceDisplayItemsLoadAction<TypeKeys.LOAD_VIRTUAL_CATALOGS, VirtualCatalog>(
        action,
        state,
        'virtualCatalogCode',
        true,
        action.forceLoad ? 0 : undefined,
        action.forceLoad
      );
      return {
        ...itemsState,
        items: action.forceLoad ? undefined : state ? state.items : undefined,
      };
    }

    case TypeKeys.LOAD_VIRTUAL_CATALOGS_FULFILLED: {
      const actionState = getPreviousActionState(TypeKeys.LOAD_VIRTUAL_CATALOGS, state, ActionPhase.IN_PROGRESS)!;
      const catalogs = mergeArrays<VirtualCatalog>('virtualCatalogCode', 'lastModified', state!.items, action.catalogs);
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.LOAD_VIRTUAL_CATALOGS,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.SUCCESS
        ),
        errors: validateLoadActionFulfilledResponseCounts(
          actionState!.query!,
          action.total,
          action.catalogs,
          state!.errors
        ),
        items: catalogs.sort(sortByLastModifiedAscVirtualCatalog),
        total: action.total,
      };
    }

    case TypeKeys.LOAD_VIRTUAL_CATALOGS_FAILED: {
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.LOAD_VIRTUAL_CATALOGS,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.FAILED
        ),
        errors: action.errors,
      };
    }

    case TypeKeys.SET_SELECTED_VIRTUAL_CATALOG: {
      return {
        ...state,
        selectedCatalogCode: action.selectedCatalogCode,
      };
    }

    case TypeKeys.CLEAR_STATE: {
      return {};
    }

    default:
      return state;
  }
}
